// @flow

import '@babel/polyfill';
import 'bootstrap/dist/css/bootstrap.css';
import 'custom-event';

import React                 from 'react';
import ReactDOM              from 'react-dom';
import App                   from './App';
import {
  API_HOST,
  API_PATH,
}                            from './config/_entrypoint';
import authConfig            from './modules/auth/config';
import editableContentConfig from './modules/editableContent/config';
import registerServiceWorker from './registerServiceWorker';

let store;

// Configure locales
require('./config/configureLocales');

// Configure Auth component
authConfig.statePath = 'auth';
authConfig.loginUrl  = `${API_HOST}${API_PATH}/login_check`;
authConfig.dispatch  = (...args) => store.dispatch(...args);

// Configure Editable Content component
editableContentConfig.statePath = 'editableContent';

require('./config/sentry');
require('./config/fontawesome');

// Setup Redux store
// We use require here, so that the reducers are not imported until the authModule is configured above.
store = require('./store').getStore();

require('./analytics/google-analytics/initGoogleAnalytics').default();

ReactDOM.render(<App store={store}/>, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js